export default __webpack_public_path__ + "static/media/5.5bb6b5a0.png";